import type { IconNode } from '../types';

/**
 * @name letter-w
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMjEgNC00Ljc5NCAxNS44MjFhLjI1LjI1IDAgMDEtLjQ3MS4wMjFsLTMuNTAzLTguNjg1YS4yNS4yNSAwIDAwLS40NjQgMGwtMy41MDMgOC42ODVhLjI1LjI1IDAgMDEtLjQ3LS4wMjFMMyA0IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/letter-w
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const LetterW: IconNode = [
  [
    'path',
    {
      d: 'm21 4-4.794 15.821a.25.25 0 01-.471.021l-3.503-8.685a.25.25 0 00-.464 0l-3.503 8.685a.25.25 0 01-.47-.021L3 4',
    },
  ],
];

export default LetterW;
